import type { TimeGrid, Weekday } from './types.js';

/** Day 0 is Monday: the order the weekly-hours editor and a creator's week read in. */
export const WEEK_FROM_MONDAY: Weekday[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

/** One open range on one day of the week, in the creator's own wall-clock time. */
export interface WeekBlock {
  /** 0..6, Monday first. */
  day: number;
  /** HH:mm; the end may be 24:00. */
  start: string;
  end: string;
}

/**
 * The stored grid: each time is a moment on 1970-01-01 UTC, shifted back by the creator's
 * UTC offset. Decorator-free, so the weekly-hours editor and the connector write one shape.
 */
export function weekToGrid(blocks: WeekBlock[], utcOffsetMinutes: number): TimeGrid {
  const at = (time: string) => {
    const [h, m] = time.split(':').map(Number);
    return new Date(Date.UTC(1970, 0, 1, h, m) - utcOffsetMinutes * 60_000);
  };
  const grid: TimeGrid = {};
  for (const block of [...blocks].sort((a, b) => a.start.localeCompare(b.start))) {
    const day = WEEK_FROM_MONDAY[block.day];
    (grid[day] ??= []).push({ start: at(block.start), end: at(block.end) });
  }
  return grid;
}

/** The week a new page opens on when nobody named one: weekday evenings, 18:00 to 21:00. */
export const DEFAULT_CLAIM_WEEK: WeekBlock[] = [0, 1, 2, 3, 4].map((day) => ({
  day,
  start: '18:00',
  end: '21:00',
}));
